import { render, staticRenderFns } from "./cooking-tips-static-cmp.vue?vue&type=template&id=61ed491c&scoped=true"
import script from "./cooking-tips-static-cmp.vue?vue&type=script&lang=js"
export * from "./cooking-tips-static-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed491c",
  null
  
)

export default component.exports